// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z-CQ","colBig":"styles_colBig__2ruPs","colSmall":"styles_colSmall__2ul3Q"};